import NoDataText from "../../../../components/emptyState/emptyStateText";

function Tel1OtherComment({ commentData = [] }) {
  return (
    <>
      <div className="d-flex mb-3">
        <div className="flex-1 d-flex">
          <div>
            <div>Lain-lain</div>
            {commentData.length > 0 ? (
              commentData.map((val, index) => (
                <div key={index} className="mb-3">
                  <div className="d-flex mt-1 text-opacity-50 small">
                    <div>
                      <i className="fa fa-circle text-warning fs-6px d-block mt-2"></i>
                    </div>
                    <div className="flex-1 ps-2">
                      <div className="text-theme">{val.text}</div>
                    </div>
                  </div>
                  {val.result.length > 0 ? (
                    val.result.map((item, ind) => (
                      <div key={ind} className="d-flex mt-1 text-inverse text-opacity-50 small">
                        <div className="flex-1 ps-3">
                          <div>{item}</div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <>
                      <div className="d-flex mt-1 text-inverse text-opacity-50 small">
                        <div className="flex-1 ps-3">
                          <div>No Data</div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              ))
            ) : (
              <NoDataText />
            )}
          </div>
        </div>
      </div>
    </>
  );
}
export default Tel1OtherComment;
